<div *ngIf="this.policyInfo.PolicyState === 'NY'">
  <app-newyork-covid-msg></app-newyork-covid-msg>
</div> 
<div *ngIf="this.policyInfo.PolicyState === 'NJ'">
  <app-nj-covid-msg></app-nj-covid-msg>
</div>

<div *ngIf="this.policyInfo.PolicyState === 'CA'">
  <app-ca-covid-msg></app-ca-covid-msg>
</div>